import { lightTheme } from '@/customTheme'
import * as React from 'react'

interface ScrollArrowProps {
  direction?: 'left' | 'right'
  size?: number
  color?: string
}

/** HTML-style line arrow (shaft + head). Left mirrors right. */
const SvgComponent = ({ direction = 'right', size = 16, color }: ScrollArrowProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? lightTheme.colors.blackGray}
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: direction === 'left' ? 'rotate(180deg)' : undefined }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 12h14" />
    <path d="M13 6l6 6-6 6" />
  </svg>
)

export default SvgComponent
